import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { SiteMap } from '.'

export const SiteMapRegistration = createRegisterableComponent(
    'site-map',
    (_, { resolution }) => {
        if (
            resolution.type !== 'server' ||
            resolution.resolution.type !== 'sitemap'
        ) {
            return null
        }

        const { siteMap } = resolution.resolution

        return <SiteMap siteMapIndex={siteMap} />
    },
)
